var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.55 2.09844L10.525 2.15678L8.10836 7.76511H5.73336C5.1667 7.76511 4.62503 7.88178 4.13336 8.09011L5.5917 4.60678L5.62503 4.52344L5.68336 4.39011C5.70003 4.34011 5.7167 4.29011 5.7417 4.24844C6.83336 1.72344 8.0667 1.14844 10.55 2.09844Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0417 7.93178C14.6667 7.81512 14.2667 7.76512 13.8667 7.76512H8.10834L10.525 2.15678L10.55 2.09845C10.675 2.14012 10.7917 2.19845 10.9167 2.24845L12.7583 3.02345C13.7833 3.44845 14.5 3.89012 14.9333 4.42345C15.0167 4.52345 15.0833 4.61512 15.1417 4.72345C15.2167 4.84012 15.275 4.95678 15.3083 5.08178C15.3417 5.15678 15.3667 5.23178 15.3833 5.29845C15.6083 5.99845 15.475 6.85678 15.0417 7.93178Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9348 11.832V13.457C17.9348 13.6236 17.9265 13.7903 17.9181 13.957C17.7598 16.8653 16.1348 18.332 13.0515 18.332H6.55145C6.35145 18.332 6.15145 18.3153 5.95979 18.2903C3.30979 18.1153 1.89312 16.6986 1.71812 14.0486C1.69312 13.857 1.67645 13.657 1.67645 13.457V11.832C1.67645 10.157 2.69312 8.7153 4.14312 8.0903C4.64312 7.88196 5.17645 7.7653 5.74312 7.7653H13.8765C14.2848 7.7653 14.6848 7.82363 15.0515 7.93196C16.7098 8.4403 17.9348 9.9903 17.9348 11.832Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59169 4.60678L4.13335 8.09011C2.68335 8.71511 1.66669 10.1568 1.66669 11.8318V9.39011C1.66669 7.02345 3.35002 5.04845 5.59169 4.60678Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9322 9.38972V11.8314C17.9322 9.99805 16.7155 8.43972 15.0488 7.93972C15.4822 6.85638 15.6072 6.00638 15.3988 5.29805C15.3822 5.22305 15.3572 5.14805 15.3238 5.08138C16.8738 5.88138 17.9322 7.52305 17.9322 9.38972Z",
    stroke: "#65717C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.fbb840e2a686c0e61657c52772d18db3.svg";
export { ForwardRef as ReactComponent };